<template>
  <Dialog
    :class="$i18n.locale"
    :visible.sync="visible"
    :title="$t('login.agreeConfirmTitle')"
    :confirmText="$t(options.confirmKey)"
    @confirm="handleConfirm"
    @cancel="handleCancel"
    @close="handleCancel"
    @touchmove.native.prevent
  >
    <div class="confirm-content">
      <i18n path="login.agreeConfirmText" tag="div">
        <a
          place="policy"
          class="link"
          :href="$utils.getPrivacyPolicyUrl($i18n.locale)"
          target="_blank"
          >{{ $t('login.agreeConfirmLink1') }}</a
        >
        <a
          place="service"
          class="link"
          :href="$utils.getTermsOfServiceUrl($i18n.locale)"
          target="_blank"
          >{{ $t('login.agreeConfirmLink2') }}</a
        >
        <a
          place="payment"
          class="link"
          :href="$utils.getPaymentTermsUrl($i18n.locale)"
          target="_blank"
          >{{ $t('login.agreeConfirmLink3') }}</a
        >
      </i18n>
    </div>
  </Dialog>
</template>

<script>
// import导入组件工具等
import { mapState } from 'vuex'
export default {
  data() {
    return {
      visible: false,
      options: {
        confirm: () => {},
        cancel: () => {},
      },
    }
  },
  created() {
    this.$root.Bus.$on('login-agree', this.agree)
  },
  // 组件方法
  methods: {
    handleConfirm() {
      this.close()
      this.options.confirm()
    },
    handleCancel() {
      this.close()
      this.options.cancel()
    },
    close() {
      this.visible = false
    },
    agree(options) {
      this.options = {
        confirm: options.confirm || (() => {}),
        cancel: options.cancel || (() => {}),
        confirmKey: options.confirmKey || 'login.agreeConfirmBtn',
      }
      this.visible = true
    },
  },
  // 计算属性
  computed: {
    ...mapState({
      isNewWebsite: (state) => state.app.isNewWebsite,
    }),
    policyUrl() {},
  },
  // 侦听器
  watch: {},
  // import的组件需要声明
  components: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.confirm-content {
  background-color: rgba(242, 244, 248, 1);
  border-radius: 8px;
  min-height: 96px;
  padding: 12px;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  .link {
    color: rgba(25, 176, 90, 1);
  }
}
</style>
